module.exports = __webpack_public_path__ + "8670c83f19ea1475cb545be7df7af8b6.svg";